import { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { displayDateRange } from "../../../../../utils/questionnaire";
import { VideoListTable } from "../../../calendar/VideoListTable";

const SummaryVideoList = ({
  start,
  end,
  date,
  athlete,
  locals,
  query,
  organizationCoachParam,
}) => {
  const [videosToShow, setVideosToShow] = useState([]);
  const [, setVideosToCompareState] = useState([]);
  const { t } = useTranslation("athlete-portal");

  // The api sorts, not the table: the video modal's prev/next is built from the
  // same list the api returns, so re-sorting these rows client side would leave
  // the coach stepping through an order they can't see.
  const isAscending = Number(query.videoSort) === 1;

  return (
    <article id="summary-video-list">
      <header>
        <div>
          <h4>{t("videoList.title")}</h4>
          <p className="p4">{displayDateRange(start, end)}</p>
        </div>

        <a
          href={`
            /athlete-portal/metrics/video-list?date=${date}&athlete=${athlete._id}${organizationCoachParam}&summary=true
            `}
          className="composition-see-more"
        >
          <span>{t("bodyComposition.seeMore")}</span>
          <SvgIcon
            noFilterOnLight={true}
            src="/img/new-icons/arrow-square-right-gradient.svg"
          />
        </a>
      </header>
      {/* biome-ignore lint/a11y/useValidAriaRole: table-wrapper used for styling */}
      <section role="table-wrapper">
        {/* biome-ignore lint/a11y/useValidAriaRole: report-table used for structure */}
        <table role="report-table">
          {videosToShow && videosToShow.length > 0 && (
            <thead>
              <tr>
                <th className="date">
                  <a
                    href={`/actions/refresh?videoSort=${isAscending ? -1 : 1}`}
                  >
                    {t("reports.date")}
                    <img alt="sort" src="/img/svg/up_down_arrows.svg" />
                  </a>
                </th>
                <th>{t("videoList.exerciseName")}</th>
                <th>{t("videoList.protocol")}</th>
                <th>{t("videoList.comments")}</th>
                <th>{t("videoList.status")}</th>
                <th>{t("videoList.watched")}</th>
                <th>{t("videoList.video")}</th>
              </tr>
            </thead>
          )}
          <VideoListTable
            locals={locals}
            query={query}
            compareState={false}
            setVideosToCompareState={setVideosToCompareState}
            videosToShow={videosToShow}
            setVideosToShow={setVideosToShow}
          />
        </table>
      </section>

      {videosToShow && videosToShow.length <= 0 && (
        <div className="no-data">
          {t("checkinSummaryComponents.noVideosToShow")}
        </div>
      )}
    </article>
  );
};

export default SummaryVideoList;
